import React from "react"
import { graphql } from "gatsby"
// temp
import "../pages/index.css";
import "../components/pagination";

import Layout from "../components/layout"
import ArticleList from "../components/article-list"
import SEO from "../components/seo"
import Pagination from "../components/pagination"

export default ({data, pageContext}) => {
  return (
    <>
      <SEO title="Archivio" keywords={['Archivio']} />
      <ArticleList articles={data.results.edges}
      tag={pageContext.humanPageNumber}
      paginator={() => (
        <Pagination pageContext={pageContext} />
      )}/>
      <div>
      <div>
        {/* previousPageLink and nextPageLink were added by the plugin */ }
        
      </div>
    </div>
    </>
  )
}
export const query = graphql`
query ($skip: Int!, $limit: Int!) {
    results: allMarkdownRemark(
      sort: {fields: [frontmatter___date], order: DESC},
      skip: $skip,
      limit: $limit,
      filter: {fileAbsolutePath: {regex: "/posts/"}}
      ) {
        totalCount
        edges {
            node {
              frontmatter {
                title
                date
                author
                slug
                thumbnail
              }
              html
              internal {
                type
                mediaType
                description
              }
              excerpt
              
            }
      
        }
    }
  }
`